/**
 * On the homepage, the header starts transparent and overlaid on the
 * full-viewport hero (see .template-index .site-header in theme.scss.liquid).
 * Once the hero (data-section-id="hero-1") scrolls out of view, this adds
 * .site-header--scrolled so the header becomes a normal solid, sticky bar --
 * necessary once the page below the hero is on a light background, where
 * white nav text would otherwise be unreadable.
 */
(function () {
  var hero = document.querySelector('[data-section-id="hero-1"]');
  var header = document.querySelector('[data-header-section] .site-header');

  if (!hero || !header || !('IntersectionObserver' in window)) {
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        header.classList.toggle('site-header--scrolled', !entry.isIntersecting);
      });
    },
    { threshold: 0 }
  );

  observer.observe(hero);
})();
